import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CarTypeService from "../../services/cartype.service";

// **Async Thunks**
export const addCarType = createAsyncThunk(
  "carType/addCarType",
  async (item, thunkAPI) => {
    try {
      const response = await CarTypeService.addCarType(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getcarType = createAsyncThunk(
  "carType/getcarType",
  async (item, thunkApi) => {
    try {
      const response = await CarTypeService.getCarType(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getcarTypeRange = createAsyncThunk(
  "carType/getCarTypeRange",
  async (item, thunkApi) => {
    try {
      const response = await CarTypeService.getCarTypeRange(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editcarType = createAsyncThunk(
  "carType/editcarType",
  async (item, thunkAPI) => {
    try {
      const response = await CarTypeService.editCarType(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteCarType = createAsyncThunk(
  "carType/deletecarType",
  async (id, thunkAPI) => {
    try {
      await CarTypeService.deleteCarType(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  carTypes: [],
  carTypeRanges: [],
};

// **Slice**
const carTypeSlice = createSlice({
  name: "carType",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Type List**
      .addCase(getcarType.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getcarType.fulfilled, (state, action) => {
        state.loading = false;
        state.carTypes = action.payload;
      })
      .addCase(getcarType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Get Car Type Range**
      .addCase(getcarTypeRange.pending, (state) => {
        state.loading = true;
      })
      .addCase(getcarTypeRange.fulfilled, (state, action) => {
        state.loading = false;
        state.carTypeRanges = action.payload;
      })
      .addCase(getcarTypeRange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Car Type**
      .addCase(addCarType.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCarType.fulfilled, (state, action) => {
        state.loading = false;
        state.carTypes.push(action.payload);
      })
      .addCase(addCarType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Type**
      .addCase(editcarType.pending, (state) => {
        state.loading = true;
      })
      .addCase(editcarType.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.carTypes.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) {
          state.carTypes[index] = action.payload;
        }
      })
      .addCase(editcarType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Type**
      .addCase(deleteCarType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCarType.fulfilled, (state, action) => {
        state.loading = false;
        state.carTypes = state.carTypes.filter((c) => c.id !== action.payload);
      })
      .addCase(deleteCarType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default carTypeSlice.reducer;
